// src/components/Layout/MainNavbar.jsx
import React from "react";
import { Navbar, Container, Nav, Button, NavDropdown } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../../assets/logo/logo.png";
import "../NavBar/NavBar.css";

const MainNavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user") || "null");
  const token = localStorage.getItem("token");
  const business = JSON.parse(localStorage.getItem("business") || "null");
  const userInitial = (user?.name || "U").charAt(0).toUpperCase();

  const isAdminRoute = location.pathname.startsWith("/admin");

  const handleLogoClick = () => {
    if (isAdminRoute && business?.slug) {
      navigate(`/admin/${business.slug}`);
    } else {
      navigate("/");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("business");
    navigate("/");
  };

  const goToRanking = () => {
    navigate("/#ranking-global-home");
  };

  return (
    <Navbar
      expand="lg"
      className="mb-0 shadow-sm main-navbar"
      style={{
        background:
          "linear-gradient(90deg, #0f172a 0%, #111827 40%, #1f2933 100%)",
      }}
      variant="dark"
    >
      <Container>
        <Navbar.Brand
          onClick={handleLogoClick}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <img src={logo} alt="QR Benefits Logo" className="navbar-logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-nav" />
        <Navbar.Collapse id="main-nav">
          {!isAdminRoute && (
            <Nav className="me-auto">
              <Nav.Link onClick={() => navigate("/")}>Beneficios</Nav.Link>
              <Nav.Link onClick={goToRanking}>Ranking</Nav.Link>
              <Nav.Link onClick={() => navigate("/landing")}>Para negocios</Nav.Link>
            </Nav>
          )}

          <Nav className="ms-auto align-items-center gap-2">
            {token ? (
              <NavDropdown
                align="end"
                id="user-menu"
                className="user-menu-dropdown"
                title={
                  <span className="user-menu-trigger">
                    <span className="user-menu-avatar">
                      {user?.avatar_url ? (
                        <img
                          src={user.avatar_url}
                          alt={user?.name || "Avatar"}
                          className="user-menu-avatar-img"
                        />
                      ) : (
                        userInitial
                      )}
                    </span>
                    <span className="d-none d-md-inline">{user?.name || "Mi cuenta"}</span>
                  </span>
                }
              >
                <NavDropdown.Item onClick={() => navigate("/my-benefits")}>
                  Mi perfil
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/my-benefits")}>
                  Mis beneficios
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/my-benefits?tab=settings")}>
                  Configurar perfil
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleLogout} className="text-danger">
                  Cerrar sesion
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Button variant="outline-light" size="sm" onClick={() => navigate("/login")}>
                Iniciar sesion
              </Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MainNavbar;
